import { AssetExtension, AssetScale } from './configs';
import { VideoSourceType } from '~/typings/media';

import type { Asset } from '~/typings/media';


const VIDEO_MIME_TYPE_REGEX = /^video\/.*/;
const IMAGE_MIME_TYPE_REGEX = /^image\/.*/;
const GIF_REGEX = /gif$/;

const isVideo = (asset: Asset): boolean =>
  VIDEO_MIME_TYPE_REGEX.test(asset?.mimeType);

const isImage = (asset: Asset): boolean =>
  IMAGE_MIME_TYPE_REGEX.test(asset.mimeType);

const isGif = (asset: Asset) => GIF_REGEX.test(asset.mimeType);

const getSourceUrl = (asset: Asset, scale = AssetScale.X_3) => {
  const { damId } = asset;

  const isVideoAsset = isVideo(asset);

  // Presently, DAM doesn't have support for video streaming. Therefor, original
  // asset url is used.
  if (isVideoAsset) {
    return asset.originalUrl;
  }
  // Uncomment this code when streaming is supported
  // if (isVideoAsset && asset.streamHlsUrl) {
  //   return asset.streamHlsUrl;
  // }

  const pathSegments: string[] = [isVideoAsset ? '' : scale, damId].filter(
    (v) => !!v
  );

  const path = pathSegments.join('/');

  const extension = isVideoAsset
    ? AssetExtension.MP4
    : isGif(asset)
    ? AssetExtension.GIF
    : AssetExtension.WEBP;

  return `${path}.${extension}`;
};

const getImageSource = (asset: Asset, scale = AssetScale.X_3): string => {
  const { damId } = asset;
  let path = `${isGif(asset) ? AssetScale.ORIGINAL : scale}/${damId}`;
  const extension = isGif(asset) ? AssetExtension.GIF : AssetExtension.WEBP;
  return `${path}.${extension}`;
};

const getVideoSource = (asset: Asset) =>
  asset.streamUrl
    ? [VideoSourceType.STREAM, asset.streamUrl, asset.originalUrl]
    : [VideoSourceType.CONTAINER, asset.originalUrl, asset.originalUrl];

export {
  getImageSource,
  getSourceUrl,
  getVideoSource,
  isGif,
  isImage,
  isVideo,
};
